import { Fragment, useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useHistory } from "react-router-dom";
import CaseloadDisplay from "../../../../api/models/caseloadDisplay";
import { getCaseloadsByDisciplineId } from "../../../../api/services/caseloadService";
import { hasValue } from "../../../../common/utils";
import AssociativeArray from "../../../../types/IAssociativeArray";
import Spinner from "../../../spinner";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import CaseloadsResponse from "../../../../api/responses/caseloadsResponse";

const fetchCaseloads = async (args: any) => await getCaseloadsByDisciplineId(args[0] ?? 1);

const DashboardWidgetTherapistCaseload = ({ discipline, user }: DashboardProps): JSX.Element => {
    const [disciplineId, setDisciplineId] = useState<number | undefined>(discipline?.disciplineId ?? 1);
    const [sortedCaseloads, setSortedCaseloads] = useState<AssociativeArray>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [caseloadIds, setCaseloadIds] = useState<number[]>([]);
    const [allCaseloads, setAllCaseloads] = useState<CaseloadDisplay[]>([]);
    const [caseloadCount, setCaseloadCount] = useState<number>(0);
    const history = useHistory();

    useEffect(() => {
        if (discipline && discipline?.disciplineId) {
            setDisciplineId(discipline?.disciplineId);
            asyncCaseloads.run(discipline?.disciplineId);
        }
    }, [discipline]);

    const handleCaseloadsResponse = (response: CaseloadsResponse) => {
        const caseloads: CaseloadDisplay[] = response.data.caseloads;
        const sorted: AssociativeArray = {};
        const caseloadIds: number[] = [];

        caseloads.forEach((caseload: CaseloadDisplay, i: number) => {
            if (!hasValue(sorted[caseload.schoolName]))
                sorted[caseload.schoolName] = [];

            sorted[caseload.schoolName].push(caseload);
            caseloadIds.push(caseload.caseloadId);
        });
        setAllCaseloads(caseloads);
        setCaseloadCount(caseloads.length);
        setSortedCaseloads(sorted);
        setCaseloadIds(caseloadIds);
    }

    //Get the user's caseload
    const asyncCaseloads = useAsync({
        deferFn: fetchCaseloads,
        onResolve: handleCaseloadsResponse
    });

    const asyncCaseloadsPromiseFn = useAsync({
        promiseFn: fetchCaseloads,
        disciplineId,
        onResolve: handleCaseloadsResponse
    });

    /**
     * Redirects to the caseloads page with the given caseloads, caseloadIds, schoolId, and districtId.
     *
     * @param {CaseloadDisplay[]} caseloads - the list of caseloads to display
     * @param {number[]} [caseloadIds] - the list of caseload ids to use for filtering
     * @param {number} [schoolId] - the id of the school to filter by
     * @param {number} [districtId] - the id of the district to filter by
     * @return {void} 
     */
    const redirectWithCaseloads = (caseloads: CaseloadDisplay[], caseloadIds?: number[], schoolId?: number, districtId?: number, disciplineId?: number) => {
        return history.push(`/caseload`, { caseloads, caseloadIds, schoolId, districtId, disciplineId });
    }

    return (
        <div className={DashboardPropsDefaults.containerClassNames ?? ''}>
            <div className="pb-1 dashboard-widget-title">
                <h3>Caseload
                    <div className="inline-block ml-1 underline cursor-pointer hover:no-underline" onClick={() => redirectWithCaseloads(allCaseloads, caseloadIds, undefined, undefined, disciplineId)}>({caseloadCount})</div>
                </h3>
            </div>
            <div className={DashboardPropsDefaults.contentClassNames}>
                <Spinner show={asyncCaseloads.isPending} />
                {!asyncCaseloads.isPending && (
                    <>
                        {sortedCaseloads !== undefined && (
                            <>
                                {Object.keys(sortedCaseloads!).map((key, i) =>
                                    <Fragment key={`schoolName-${i}`}>
                                        <div className=''>{key}&nbsp;
                                            (<span className="mb-2 font-normal underline cursor-pointer hover:no-underline text-ptsblue-500"
                                                onClick={(e) => redirectWithCaseloads(sortedCaseloads[key], undefined, sortedCaseloads[key][i] !== undefined ? sortedCaseloads[key][i].schoolId : 0, sortedCaseloads[key][i] !== undefined ? sortedCaseloads[key][i].districtId : 0, disciplineId)}>{sortedCaseloads[key].length}
                                            </span>)
                                        </div>
                                    </Fragment>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default DashboardWidgetTherapistCaseload;
